import { render, staticRenderFns } from "./VehicleLookupDetail.vue?vue&type=template&id=95f643f8"
import script from "./VehicleLookupDetail.vue?vue&type=script&lang=js"
export * from "./VehicleLookupDetail.vue?vue&type=script&lang=js"
import style0 from "./VehicleLookupDetail.vue?vue&type=style&index=0&id=95f643f8&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95f643f8')) {
      api.createRecord('95f643f8', component.options)
    } else {
      api.reload('95f643f8', component.options)
    }
    module.hot.accept("./VehicleLookupDetail.vue?vue&type=template&id=95f643f8", function () {
      api.rerender('95f643f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vehiclelookup/VehicleLookupDetail.vue"
export default component.exports